<template>
  <div style="height:100%">
<!--    <van-nav-bar-->
<!--        class="navbar"-->
<!--        :title="translateTitle('续费管理')"-->
<!--        left-arrow-->
<!--        @click-left="goBack"-->
<!--        v-if="rendered.isNav"-->
<!--    >-->
<!--      <template #left>-->
<!--        <van-icon name="arrow-left" size="18" color="#000000"/>-->
<!--      </template>-->
<!--    </van-nav-bar>-->
    <div class="container" >
      <div class="container-box" :style="imageUrl"></div>
    </div>
  </div>
</template>

<script>
import {reactive,toRefs} from "vue";
import router from "@/router";
import {translateTitle} from "@/utils/i18n";
import {useFourGFlowStore} from "@/store/modules/FourGFlow";
import {WebViewBridge} from "@/utils/bridge";

export default {
  name: "RenewalManagement",
  setup() {
    const fourGFlowStore = useFourGFlowStore()
    //必要参数渲染参数
    let {renderedParams: rendered} = fourGFlowStore

    console.log("rendered",rendered);

    const state = reactive({
      imageUrl: {
        backgroundImage: 'url(' + require('@/assets/' + translateTitle('续费管理.png'))+ ')',
        height: window.innerHeight + 750 + "px",
      }
    })

    const webViewBridge = new WebViewBridge()
    webViewBridge.init().then(()=>{
      webViewBridge.callHandler('getOEMID', "", (data) => {
        //获取客户端编号
        if(data === 'AKCXKJ')
          state.imageUrl.backgroundImage = 'url(' + require('@/assets/' + translateTitle('奥凯续费管理.png'))+ ')'
      });
    })

    const goBack = () => {
      router.go(-1)
    }
    return {
      ...toRefs(state),
      goBack,
      translateTitle,
      rendered
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  //height: 90%;
  width: 100%;
  overflow-y: scroll;
  //margin-top: 56px;

  &::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }

  &-box {
    width: 100%;
    //height: 1400px;
    //background: url('../../../public/img/续费管理.png') no-repeat;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
}
.navbar {
  color: #fff;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 99;
  padding-top: 10px;
}
</style>